import { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { getCoupon } from '../../../actions/coachCertificationActions'
import Input from '../../common/form/Input'

import classes from './PriceCard.module.scss'

const CouponField = ({ certificationId, coupon, onChange }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [code, setCode] = useState('')
  const [error, setError] = useState(null)
  const [isApplying, setIsApplying] = useState(false)
  const canApply = code.trim() !== '' && !isApplying

  const handleApply = (e) => {
    e.preventDefault()
    if (!canApply) { return }
    setError(null)
    setIsApplying(true)
    dispatch(getCoupon({ certificationId, code: code.trim() })).unwrap()
      .then((payload) => { onChange(payload.coupon); setCode('') })
      .catch((errors) => {
        setError(errors?.code?.[0] || t(errors?.status === 404 ? 'portal.certification.priceCard.invalidCoupon' : 'common.somethingWentWrong'))
      })
      .finally(() => setIsApplying(false))
  }

  if (coupon) {
    return (
      <p className={classNames('d-flex align-items-center mb-3', classes.couponApplied)}>
        <i className='fa fa-check-circle mr-2' aria-hidden='true' />
        <span className='flex-grow-1'>
          {t('portal.certification.priceCard.couponApplied', { label: coupon.label || coupon.code, percent: coupon.percentOff })}
        </span>
        <button type='button' className={classes.textLink} onClick={() => onChange(null)}>{t('portal.certification.priceCard.removeCoupon')}</button>
      </p>
    )
  }

  return (
    <form onSubmit={handleApply} className='mb-3'>
      <Input
        id='couponCode'
        type='text'
        value={code}
        placeholder={t('portal.certification.priceCard.couponPlaceholder')}
        aria-label={t('portal.certification.priceCard.couponLabel')}
        error={error}
        classNames={{ inputContainer: classes.couponContainer }}
        onChange={(e) => { setCode(e.target.value); setError(null) }}
        endAdornment={(
          <button type='submit' className={classes.applyButton} disabled={!canApply}>
            {isApplying ? <i className='fa fa-spinner fa-spin' aria-hidden='true' /> : t('portal.certification.priceCard.apply')}
          </button>
        )}
      />
    </form>
  )
}

CouponField.propTypes = {
  certificationId: PropTypes.number.isRequired,
  coupon: PropTypes.shape({ code: PropTypes.string.isRequired, label: PropTypes.string, percentOff: PropTypes.number.isRequired }),
  onChange: PropTypes.func.isRequired,
}

export default CouponField
